var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPremiumChatDesktop = function SvgPremiumChatDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "var(--color-circle)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.023 30.093v-.1a13.993 13.993 0 0 0-27.986 0v.1a4.997 4.997 0 0 0-3.998 4.897v3.998a4.998 4.998 0 0 0 4.998 4.998h1.999a2.998 2.998 0 0 0 2.998-2.998v-7.996a2.999 2.999 0 0 0-2.998-2.999h-1a11.994 11.994 0 1 1 23.988 0h-1a2.998 2.998 0 0 0-2.998 2.999v7.995a2.999 2.999 0 0 0 2.999 2.999h1.439a10.575 10.575 0 0 1-8.176 7.736 2.98 2.98 0 0 0-2.699-1.719h-4.158a2.999 2.999 0 1 0 0 5.997h4.158a2.999 2.999 0 0 0 2.919-2.299 12.534 12.534 0 0 0 9.995-9.995 4.998 4.998 0 0 0 3.458-4.738V34.97a4.997 4.997 0 0 0-3.938-4.877Zm-24.987 1.899a1 1 0 0 1 1 1v7.995a1 1 0 0 1-1 1h-2a2.999 2.999 0 0 1-2.998-2.998V34.99a2.998 2.998 0 0 1 2.999-2.999h1.999Zm12.553 21.989h-4.158a1 1 0 0 1 0-1.999h4.158a1 1 0 0 1 0 1.999Zm14.433-15.013a2.998 2.998 0 0 1-2.998 2.999h-2a1 1 0 0 1-.999-1v-7.995a1 1 0 0 1 1-1h1.999a2.998 2.998 0 0 1 2.998 2.998v3.998Z",
    fill: "url(#PremiumChatDesktop_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PremiumChatDesktop_svg__a",
    x1: 18.039,
    y1: 36,
    x2: 53.961,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "var(--color-a)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "var(--color-b)"
  })))));
};

export default SvgPremiumChatDesktop;